module.exports={
  noResult:            'Airline not found'
}
